import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTIONS_VERIFY_OTP } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import axios from "axios";
import { toast } from "../../components/app-toast";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

export const verifyOtp = createAsyncThunk(
  ACTIONS_VERIFY_OTP.verify_otp, // You must add this in your action-types file
  async (payload) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APP_PATH.verifyOtp,
        payload,
      );
      //  toast.success(response?.data?.message)
      console.log("Verify OTP Response:", response?.data?.message);
      const message = getLocalizedMessage(response, i18n);
      toast.success(message);
      return response;
    } catch (error) {
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message || i18n.t("toast.somethingWentWrong"));
      console.log("Verify OTP Error:", error?.response?.data?.message);
      throw error;
    }
  },
);
